import { formatAED } from "./currency";

export const COD_MINIMUM_ORDER_TOTAL_AED = 500;

export const COD_MINIMUM_ORDER_MESSAGE = `Cash on Delivery is available only for orders of ${formatAED(
  COD_MINIMUM_ORDER_TOTAL_AED,
)} or above.`;

export const isCodAvailableForTotal = (amount) =>
  Number(amount || 0) >= COD_MINIMUM_ORDER_TOTAL_AED;
